// Module
var code = "<svg>\n  <use data-bind=\"attr: {\n    href: '#' + icon\n  }\"></use>\n</svg>\n";
// Exports
module.exports = code;